
<!-- MODAL POPUP -->
<div class="modal fade" id="lessonstatmodal" data-keyboard="false" data-backdrop="static" tabindex="100" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Lesson stats</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">        
        <div *ngIf="isLessonStatLoading else loadtemplate">          
          loading data...
        </div>  
        <ng-template #loadtemplate>
          <div class="text-center"
            [ngStyle]="{'background-color': lessonStat?.passed ? 'var(--success-soft)' : !lessonStat?.passed && hasAnyLessonStarted(lessonStat?.lessons) ? 'var(--warn-soft)' : 'var(--danger-soft)', 'color': 'var(--ink)'}">
            {{lessonStat?.passed ? 'Passed' : !lessonStat?.passed && hasAnyLessonStarted(lessonStat?.lessons) ? 'Not Passed' : 'No Lesson Completed'}}
          </div>
          <p>Score Percentage: {{lessonStat?.scorePercentage}}%</p>
          <p>Attendance Percentage: {{lessonStat?.attendancePercentage}}%</p>
          <app-milestone 
            [activateLessonDeadlineNotification]="lessonStat?.activateLessonDeadlineNotification" 
            [lessons]="lessonStat?.lessons"
            [enrolledDate]="lessonStat?.enrolledDate"
          >
          </app-milestone>
        </ng-template>      
        <div class="d-flex justify-content-center flex-wrap gap-1.5 mt-3">
          <button type="button" class="btn m-0" data-dismiss="modal">Done</button>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="overview" *ngIf="moduleStats?.activeStudentsCount > 0">

  <div class="statcards">
    <!-- Lead: course size and who has started -->
    <div class="statlead" *ngIf="overviewLead">
      <div class="statlead__figures">
        <div>
          <div class="statlead__label"><i class="fas fa-users" aria-hidden="true"></i> Active Students</div>
          <div class="statlead__value">{{overviewLead.active}}</div>
          <div class="statlead__note">Currently enrolled</div>
        </div>
        <div>
          <div class="statlead__label"><i class="fas fa-book-open" aria-hidden="true"></i> Total Lessons</div>
          <div class="statlead__value">{{overviewLead.lessons}}</div>
          <div class="statlead__note">Published on this course</div>
        </div>
      </div>
      <div class="statlead__split">
        <div class="statlead__bar" role="img"
             [attr.aria-label]="overviewLead.started + ' started, ' + overviewLead.notStarted + ' not started'">
          <span class="is-started" [style.width.%]="overviewLead.startedPct"></span>
        </div>
        <div class="statlead__legend">
          <span><i class="dot dot--started"></i> {{overviewLead.started}} started</span>
          <span><i class="dot dot--idle"></i> {{overviewLead.notStarted}} not started</span>
        </div>
      </div>
    </div>

    <!-- Outcomes: each as a share of active students -->
    <div class="statcard" *ngFor="let card of summaryCards" [ngClass]="'statcard--' + card.tone">
      <div class="statcard__head">
        <span class="statcard__icon" [ngClass]="'statcard__icon--' + card.tone">
          <i [ngClass]="card.icon" aria-hidden="true"></i>
        </span>
        <span class="statcard__pct">{{card.pct}}%</span>
      </div>
      <div class="statcard__value">{{card.value}}</div>
      <div class="statcard__label">{{card.label}}</div>
      <div class="statcard__meter"><span [style.width.%]="card.pct"></span></div>
      <div class="statcard__note">{{card.note}}</div>
    </div>
  </div>

</section>
<app-tablelayout 
    [data]="students" 
    [filterItems]="filterOptions" 
    [count]="count"
    [columns]="columns"
    [columnsToRemove]="removeColumn"
    [offset]="25" 
    [allowExport]="true"
    exportFileName="course-students"
    [noRecordText]="noStudentText"
    (loadDataEvent)="loadTableData($event)"
    (rowClicked)="rowClicked($event)"
    >
<app-tablelayout/>

